export class AnswerAddRequest {
    readonly answers: string[]

    constructor(answer: string[]) {
        this.answers = answer;
    }
}
